<template>
    <import-wizard
    type="orders"
    :height="height"
    accept="text/xml"
    :file-label="$t('imports.orders.fileLabel')"
    :analysis.sync="stats"
    :selectedTags="selectedTags"
    :class="classes"
    @close="close"
    >
      <template #title>
        {{$t('imports.orders.title')}}
      </template>

      <template #analysis>
        <v-list id="pfid1618852826">
          <v-list-item><v-list-item-icon><v-icon>$rows</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.orders.count')}}</v-list-item-subtitle><v-list-item-title>{{stats.orders}}</v-list-item-title></v-list-item-content></v-list-item>
          <v-list-item><v-list-item-icon><v-icon>$calendarFrom</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.orders.from')}}</v-list-item-subtitle><v-list-item-title>{{formatDate(stats.from)}}</v-list-item-title></v-list-item-content></v-list-item>
          <v-list-item><v-list-item-icon><v-icon>$calendarTo</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.orders.to')}}</v-list-item-subtitle><v-list-item-title>{{formatDate(stats.to)}}</v-list-item-title></v-list-item-content></v-list-item>
          <v-list-item><v-list-item-icon><v-icon>$sales</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.orders.sales')}}</v-list-item-subtitle><v-list-item-title>{{stats.total}}{{ formatCurrency(item.currency, true) }}</v-list-item-title></v-list-item-content></v-list-item>
          <v-list-item><v-list-item-icon><v-icon>$mailing</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.contacts.emails')}}</v-list-item-subtitle><v-list-item-title>{{stats.emails}}</v-list-item-title></v-list-item-content></v-list-item>
      </v-list>
      <v-alert v-if="error" type="error"  colored-border border="left">{{$t('imports.orders.limit', {limit: 50000})}}</v-alert>

      </template>

      <template #results="{ job }">
        <v-subheader>{{$t('imports.orders.orders')}}</v-subheader>
          <v-list-item><v-list-item-icon><v-icon>$ok</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.contacts.imported')}}</v-list-item-subtitle><v-list-item-title>{{job.data.orders.imported}}</v-list-item-title></v-list-item-content></v-list-item>
          <v-list-item><v-list-item-icon><v-icon>$nok</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.contacts.present')}}</v-list-item-subtitle><v-list-item-title>{{job.data.orders.skipped}}</v-list-item-title></v-list-item-content></v-list-item>
          <v-list-item><v-list-item-icon><v-icon>$nok</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.contacts.ignored')}}</v-list-item-subtitle><v-list-item-title>{{job.data.orders.ignored}}</v-list-item-title></v-list-item-content></v-list-item>
        <v-subheader>{{$t('imports.contacts.emails')}}</v-subheader>
        <v-list subheader>
          <v-list-item><v-list-item-icon><v-icon>$ok</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.contacts.imported')}}</v-list-item-subtitle><v-list-item-title>{{job.data.emails.imported}}</v-list-item-title></v-list-item-content></v-list-item>
          <v-list-item><v-list-item-icon><v-icon>$refreshed</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.contacts.updated')}}</v-list-item-subtitle><v-list-item-title>{{job.data.emails.updated}}</v-list-item-title></v-list-item-content></v-list-item>
          <v-list-item><v-list-item-icon><v-icon>$nok</v-icon></v-list-item-icon><v-list-item-content><v-list-item-subtitle>{{$t('imports.contacts.present')}}</v-list-item-subtitle><v-list-item-title>{{job.data.emails.skipped}}</v-list-item-title></v-list-item-content></v-list-item>
        </v-list>
      </template>
    </import-wizard>
</template>
<script>

import ImportWizard from '@/components/ImportWizard'
import Formatters from '@/mixins/formatters'
import {mapState} from 'vuex'

export default {
    name: 'ContactImport',
    components: {ImportWizard},
    mixins: [Formatters],
    props: {},
    data() {
        return {
            stats: null,
        }
    },
    computed: {
        error() {
          if(!this.stats) {
            return false;
          }
          return this.stats?.emails > 100000
        },
         classes() {
          return {
            'mt-3': !this.$route.meta.dialog
          }
        },
         height() {
          return this.$route.meta.dialog ? '880px' : null
        },
        selectedTags() {
          return this.$route.params.segment ? [this.$route.params.segment] : null 
        },
        ...mapState('domains', ['item'])
    },
    methods: {
        close() {
         this.$router.go(-1);
          
         /*
         let parentName = this.$route.matched[this.$route.matched.length -1].parent.name;
          if(parentName) {
            this.$router.push({name: parentName});  
          } else {
            // NASTY!!
            this.$router.push(this.$route.path.substring(0,this.$route.path.lastIndexOf('/order-import')));
          }
          */

        }
    }
}
</script>